import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { UIRouter } from '@uirouter/angular';
import { map } from 'rxjs/operators';
import { ApiService } from '../../api.service';

interface RegisterForm {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  extraPhoneNumber?: string;
  school: string;
  city: string;
  address: string;
  code: string;
  contractId: number;
  password: string;
}


// https://coryrylan.com/blog/angular-form-builder-and-validation-management
@Component({
  selector: 'mea-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
  registerForm: FormGroup;
  working: boolean;
  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private router: UIRouter) {
    this.working = false;
    this.registerForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email], this.validateEmailNotTaken.bind(this)],
      password: ['', Validators.required],
      code: ['', [Validators.required, Validators.pattern('[0-9]{6}')]],
      contractId: ['', [Validators.required, Validators.pattern('[0-9]+')]],

      phoneNumber: ['', [Validators.required, Validators.pattern('[0-9\-]+[0-9]')]],
      extraPhoneNumber: ['', Validators.pattern('[0-9\-]+[0-9]')],
      school: ['', Validators.required],
      city: ['', Validators.required],
      address: ['', Validators.required],
    });
  }

  @HostListener('window:message', ['$event'])
  onMessage(event) {
    if (event.data.type && event.data.type === 'MeaPayment') {
      console.log(event);
      debugger;
    }
  }

  ngOnInit() {
  }

  onSubmit(details: RegisterForm) {
    this.working = true;
    this.registerForm.get('code').setErrors(null);
    const contractId = +details.contractId;

    this.apiService.register({
      firstName: details.firstName,
      lastName: details.lastName,
      email: details.email,
      password: details.password,
      contractId,
      phoneNumber: details.phoneNumber,
      schoolName: details.school,
      city: details.city,
      address: details.address,
      code: details.code,
      extraPhoneNumber: details.extraPhoneNumber,
    }).subscribe({
      next: (response) => {
        this.working = false;
        this.registerForm.reset();
        this.router.stateService.go('login');
      },
      error: (error) => {
        this.working = false;
        if (error.error && error.error.error) {
          if (error.error.error.startsWith('security code')) {
            this.registerForm.get('code').setErrors({ invalidCode: true });
          }
        }
      }
    });
  }

  getErrorMessage(field) {
    const control = this.registerForm.get(field);
    return control.hasError('required') ? 'שדה חובה' :
      control.hasError('email') ? 'כתובת אימייל לא חוקית' :
        control.hasError('emailTaken') ? 'כתובת האימייל קיימת כבר במערכת' :
          control.hasError('pattern') ? 'יש להשתמש בספרות בלבד' :
            control.hasError('invalidCode') ? 'קוד הרשמה לא פעיל' :
              '';
  }

  validateEmailNotTaken(control: AbstractControl) {
    // TODO add debounce time and disctintUntilChanged
    return this.apiService.isEmailExists(control.value).pipe(
      map(exists => {
        return exists ? { emailTaken: true } : null;
      })
    );
  }
}
